import DateHelper from "../../../helpers/date.helper";
import { Region } from "../models/calculation-api.types";
import { CalculatorField, CalculatorQuestion } from "../models/CalculatorStep";

const optionsYesNo = [
  { text: "Nee", value: "false" },
  { text: "Ja", value: "true" },
];

export const childQuestions: CalculatorQuestion[] = [
  {
    field: CalculatorField.ChildBirthdate,
    title: "Geef de geboortedatum op van je kind",
    input: "date",
    blocking: (state) => {
      const birthdate = state[CalculatorField.ChildBirthdate];
      if (
        birthdate &&
        new Date(birthdate) &&
        DateHelper.calculateAge(new Date(birthdate)) >= 25
      ) {
        return true;
      }
      return false;
    },
  },
  {
    field: CalculatorField.ChildName,
    title: "Geef de naam op van je kind",
    input: "string",
  },
  {
    field: CalculatorField.ChildOldSystem,
    title: "STATIC: In welke situatie bevind het kind zich?",
    input: "option",
    options: [
      { text: "STATIC: OUD", value: "old" },
      { text: "STATIC: NIEUW", value: "new" },
    ],
    visible: (state, region) => {
      if (region !== Region.Flanders) {
        return false;
      }

      const birthdate = state[CalculatorField.ChildBirthdate];
      if (
        birthdate &&
        new Date(birthdate)
      ) {
        const date = new Date(birthdate);
        // groeipakket is automatic for children born from 2019+
        return date.getFullYear() < 2019
      }
      return false;
    },
  },
  {
    input: "option",
    field: CalculatorField.ChildPlaced,
    title: "STATIC: Is het kind geplaatst?",
    options: [
      { value: "no", text: "STATIC:Nee" },
      { value: "institution", text: "STATIC:Instelling" },
      { value: "foster", text: "STATIC:Pleeggezin" },
    ],
    blocking: (state) => {
      return (
        state[CalculatorField.ChildPlaced] === "institution" ||
        state[CalculatorField.ChildPlaced] === "foster"
      );
    },
  },
  {
    input: "option",
    field: CalculatorField.ChildRequiresAssistance,
    title: "Kind met specifieke ondersteuningsbehoefte?",
    description:
      "Een aandoening/handicap die erkend is door de FOD Sociale Zekerheid of door Kind en Gezin.",
    options: optionsYesNo,
  },
  {
    input: "option",
    field: CalculatorField.ChildHandicap,
    options: [
      {
        value: "1",
        text: "Minstens 4 punten in de 1ste pijler en minder dan 6 punten over de drie pijlers",
      },
      {
        value: "2",
        text: "6 – 8 punten over de drie pijlers en minder dan 4 punten in de 1ste pijler",
      },
      {
        value: "3",
        text: "9 – 11 punten over de drie pijlers en minder dan 4 punten in de 1ste pijler",
      },
      {
        value: "4",
        text: "6 – 8 punten over de drie pijlers en ten minste 4 punten in de 1ste pijler",
      },
      {
        value: "5",
        text: "9 – 11 punten in de drie pijlers en ten minste 4 punten in de 1ste pijler",
      },
      {
        value: "6",
        text: "12 – 14 punten over de drie pijlers",
      },
      {
        value: "7",
        text: "15 – 17 punten over de drie pijlers",
      },
      {
        value: "8",
        text: "18 – 20 punten over de drie pijlers",
      },
      {
        value: "9",
        text: "+ 20 punten over de drie pijlers",
      },
    ],
    visible: (state) =>
      state[CalculatorField.ChildRequiresAssistance] === "true",
  },
  {
    input: "option",
    field: CalculatorField.ChildHasDeadParents,
    title: "Is een of meerdere ouders overleden?",
    description:
      "Zo ja, dan zijn er twee extra vragen nodig voor de simulatie.",
    options: optionsYesNo,
  },
  {
    input: "option",
    field: CalculatorField.ChildOrphanAfter2018,
    title: "Werd het kind wees na 31/12/2018?",
    options: optionsYesNo,
    visible: (state, region) => {      
      const birthdate = state[CalculatorField.ChildBirthdate];
      const year = !!(birthdate && new Date(birthdate)) && new Date(birthdate).getFullYear()

      if (region === Region.Brussels && year > 2019) {
        return false;
      }

      if (region !== Region.Brussels && year > 2018) {
        return false;
      }

      return state[CalculatorField.ChildHasDeadParents] === "true"
    }
  },
  {
    input: "option",
    field: CalculatorField.ChildOneOrBothParentsDead,
    title: "Is de enige ouder of beide ouders overleden?",
    options: [
      { value: "one", text: "1 ouder overleden" },
      { value: "two", text: "Beide ouders overleden" },
    ],
    visible: (state) => state[CalculatorField.ChildHasDeadParents] === "true",
  },
  // {
  //   field: CalculatorField.ChildSingleParentLivesAlone,
  //   title:
  //     'Is de overlevende ouder alleenstaande, niet (her)gehuwd, en verblijft er geen enkele niet verwante persoon in het gezin?',
  //   options: optionsYesNo,
  //   visible: (state) =>
  //     state[CalculatorField.ChildOneOrBothParentsDead] === 'one',
  // },
];
